module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.isLoading),
      expression: "isLoading",
      modifiers: {
        "body": true
      }
    }],
    ref: "form",
    staticClass: "post-form",
    attrs: {
      "model": _vm.form,
      "label-width": "80px"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 0
    }
  }, [_c('el-col', {
    attrs: {
      "span": 18
    }
  }, _vm._l((_vm.prevItems), function(item, index) {
    return _c('el-form-item', {
      key: index,
      attrs: {
        "label": item.label
      }
    }, [(item.type === 'input') ? _c('el-input', {
      attrs: {
        "placeholder": item.description || ''
      },
      model: {
        value: (_vm.form[item.prop]),
        callback: function($$v) {
          _vm.$set(_vm.form, item.prop, $$v)
        },
        expression: "form[item.prop]"
      }
    }) : _vm._e(), _vm._v(" "), (item.type === 'markdown') ? _c('markdown', {
      attrs: {
        "toc": _vm.form[item.subProp]
      },
      on: {
        "change": function($event) {
          _vm.form[item.subProp] = arguments[0]
        }
      },
      model: {
        value: (_vm.form[item.prop]),
        callback: function($$v) {
          _vm.$set(_vm.form, item.prop, $$v)
        },
        expression: "form[item.prop]"
      }
    }) : _vm._e(), _vm._v(" "), (item.type === 'radio') ? _c('el-radio', {
      attrs: {
        "label": item.label
      },
      model: {
        value: (_vm.form[item.prop]),
        callback: function($$v) {
          _vm.$set(_vm.form, item.prop, $$v)
        },
        expression: "form[item.prop]"
      }
    }) : _vm._e()], 1)
  })), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label-width": "20px"
    }
  }, [_c('el-button', {
    class: {
      'margin-left': true
    },
    attrs: {
      "type": "info"
    },
    nativeOn: {
      "click": function($event) {
        _vm.jump('prev')
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-d-arrow-left"
  })]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "info"
    },
    nativeOn: {
      "click": function($event) {
        _vm.jump('next')
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-d-arrow-right"
  })])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "20px"
    }
  }, [_c('el-button', {
    class: {
      'margin-left': true
    },
    attrs: {
      "type": "info"
    },
    nativeOn: {
      "click": function($event) {
        _vm.onSaveToc($event)
      }
    }
  }, [_vm._v("生成目录")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success"
    },
    nativeOn: {
      "click": function($event) {
        _vm.onSubmit($event)
      }
    }
  }, [_vm._v("提交文章")])], 1), _vm._v(" "), _vm._l((_vm.nextItems), function(item, index) {
    return _c('el-form-item', {
      key: index,
      attrs: {
        "label": item.label
      }
    }, [(item.type === 'markdown') ? _c('markdown', {
      model: {
        value: (_vm.form[item.prop]),
        callback: function($$v) {
          _vm.$set(_vm.form, item.prop, $$v)
        },
        expression: "form[item.prop]"
      }
    }) : _vm._e(), _vm._v(" "), (item.type === 'date-picker') ? _c('el-date-picker', {
      attrs: {
        "type": "datetime",
        "placeholder": "选择日期时间"
      },
      model: {
        value: (_vm.form[item.prop]),
        callback: function($$v) {
          _vm.$set(_vm.form, item.prop, $$v)
        },
        expression: "form[item.prop]"
      }
    }) : _vm._e(), _vm._v(" "), (item.type === 'select') ? _c('el-select', {
      attrs: {
        "multiple": ""
      },
      model: {
        value: (_vm.form[item.prop]),
        callback: function($$v) {
          _vm.$set(_vm.form, item.prop, $$v)
        },
        expression: "form[item.prop]"
      }
    }, _vm._l((_vm.tags), function(tag, index) {
      return _c('el-option', {
        key: index,
        attrs: {
          "label": tag,
          "value": tag
        }
      })
    })) : _vm._e(), _vm._v(" "), (item.type === 'radio') ? _c('el-select', {
      model: {
        value: (_vm.form[item.prop]),
        callback: function($$v) {
          _vm.$set(_vm.form, item.prop, $$v)
        },
        expression: "form[item.prop]"
      }
    }, _vm._l((_vm.cates), function(cate, index) {
      return _c('el-option', {
        key: index,
        attrs: {
          "label": cate,
          "value": cate
        }
      })
    })) : _vm._e(), _vm._v(" "), (item.type === 'switch') ? _c('el-switch', {
      model: {
        value: (_vm.form[item.prop]),
        callback: function($$v) {
          _vm.$set(_vm.form, item.prop, $$v)
        },
        expression: "form[item.prop]"
      }
    }) : _vm._e()], 1)
  })], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-95a57306","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/containers/Post.vue
// module id = aDLC
// module chunks = 1